// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".effecr-evaluation-end[data-v-26e1a14c]{min-height:200px}.green[data-v-26e1a14c]{color:#2cb774}.text-spacing[data-v-26e1a14c]{margin-bottom:2%;font-size:1.2rem;font-weight:700;color:#333}.big-end-form-btn-right[data-v-26e1a14c]{margin-top:10px}.big-end-form-btn-right span[data-v-26e1a14c]{text-decoration:underline;cursor:pointer}", ""]);
// Exports
module.exports = exports;
